module.exports = __webpack_public_path__ + "img/step2-b.dd37b424.png";